import AutoPaginatedTable from './AutoPaginatedTable'
import PaginatedTable from './PaginatedTable'

export {AutoPaginatedTable, PaginatedTable}
